import * as React from 'react';
import { TInputSize } from '@cian/ui-kit';

import { TRadioButtonTheme, TControlProps } from './types';
import { ControlButton } from './components/ControlButton';

export interface IRadioButtonProps extends TControlProps {
  // NOTE: value может быть number
  value?: string | number;
  label: string | number;
  size?: TInputSize;
  // NOTE: добавил темизацию
  theme?: TRadioButtonTheme;
}

export const RadioButton = React.forwardRef(function RadioButton(
  props: IRadioButtonProps,
  ref: React.Ref<HTMLLabelElement>,
) {
  return <ControlButton {...props} ref={ref} type="radio" />;
});
